import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Circle } from 'lucide-react';
const defaultColors = {
    // Articles
    draft: { bg: 'bg-gray-50', text: 'text-gray-600', dot: 'text-gray-400' },
    submitted: { bg: 'bg-amber-50', text: 'text-amber-700', dot: 'text-amber-400' },
    scheduled: { bg: 'bg-blue-50', text: 'text-blue-700', dot: 'text-blue-400' },
    published: { bg: 'bg-emerald-50', text: 'text-emerald-700', dot: 'text-emerald-400' },
    expired: { bg: 'bg-gray-50', text: 'text-gray-400', dot: 'text-gray-300' },
    archived: { bg: 'bg-gray-50', text: 'text-gray-400', dot: 'text-gray-300' },
    // Reports
    pending: { bg: 'bg-amber-50', text: 'text-amber-700', dot: 'text-amber-400' },
    in_progress: { bg: 'bg-blue-50', text: 'text-blue-700', dot: 'text-blue-400' },
    completed: { bg: 'bg-green-50', text: 'text-green-700', dot: 'text-green-400' },
    resolved: { bg: 'bg-emerald-50', text: 'text-emerald-700', dot: 'text-emerald-400' },
    rejected: { bg: 'bg-red-50', text: 'text-red-700', dot: 'text-red-400' },
    // General
    active: { bg: 'bg-emerald-50', text: 'text-emerald-700', dot: 'text-emerald-400' },
    inactive: { bg: 'bg-red-50', text: 'text-red-600', dot: 'text-red-400' },
    unpublished: { bg: 'bg-gray-50', text: 'text-gray-600', dot: 'text-gray-400' },
};
const labels = {
    draft: 'Brouillon',
    submitted: 'Soumis',
    scheduled: 'Planifié',
    published: 'Publié',
    expired: 'Périmé',
    archived: 'Archivé',
    pending: 'En attente',
    in_progress: 'En cours',
    completed: 'Traité',
    resolved: 'Résolu',
    rejected: 'Refusé',
    active: 'Actif',
    inactive: 'Inactif',
    closed: 'Clôturé',
    unpublished: 'Non publié',
    manual: 'Manuel',
    cms: 'CMS',
    voirie: 'Voirie',
    eclairage: 'Éclairage',
    proprete: 'Propreté',
    espaces_verts: 'Espaces verts',
    autre: 'Autre',
    culturel: 'Culturel',
    sportif: 'Sportif',
    municipal: 'Municipal',
    associatif: 'Associatif',
    starter: 'Starter',
    standard: 'Standard',
    premium: 'Premium',
    admin: 'Admin',
    operateur: 'Opérateur',
};
export function StatusBadge({ status, colorMap }) {
    // Legacy flat colorMap support
    if (colorMap) {
        const cls = colorMap[status] ?? 'bg-gray-100 text-gray-600';
        return (_jsx("span", { className: `inline-flex items-center px-2 py-0.5 rounded-md text-[11px] font-semibold ${cls}`, children: labels[status] ?? status.replace(/_/g, ' ') }));
    }
    const colors = defaultColors[status];
    const label = labels[status] ?? status.replace(/_/g, ' ');
    if (!colors) {
        return (_jsx("span", { className: "inline-flex items-center gap-1 px-2 py-0.5 rounded-md bg-gray-50 text-[11px] font-semibold text-gray-500", children: label }));
    }
    return (_jsxs("span", { className: `inline-flex items-center gap-1.5 px-2 py-0.5 rounded-md text-[11px] font-semibold ${colors.bg} ${colors.text}`, children: [_jsx(Circle, { size: 6, className: `fill-current ${colors.dot}` }), label] }));
}
